import React from 'react';
import Select from 'rp-react-select';

export default function FilterSelect(props) {
    return (
        <Select
            labelGetter="name"
            /* eslint max-len:0 */
            noOptionsMessage="No available options matching your search criteria. Amend your search or use the reset button to start again."
            {...props}
        />
    );
}



// WEBPACK FOOTER //
// ./src/js/components/FilterSelect/FilterSelect.js